module.exports = __webpack_public_path__ + "static/img/xFIND-Logo_2018.f0866c5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xFIND-Logo_2018.svg
// module id = e5n4
// module chunks = 2